export const DEZSR_V1ResourcesEN: DEZSR_V1ResourcesBSInterface = {
  labelDone: "Task completion date",
  errors: {
    registerPic: "The picture you are uploading is too large.",
    recordAlreadyExists:
      "This evidence has already been filled out. You cannot fill it out again.",
  },
  input: {
    naziv: {
      label: "Name *",
      key: "naziv",
      placeholder: "Please enter name",
      error: "Please enter name",
    },
    primjena: {
      label: "Application",
      key: "primjena",
      placeholder: "Please enter application",
    },
    upustvoZaUpotrebu: {
      label: "Instructions for use",
      key: "upustvoZaUpotrebu",
      placeholder: "Please enter how it is applied",
    },
    vrsta: {
      label: "Type",
      key: "vrsta",
      placeholder: "Type of product according to manufacturer's declaration",
    },
    slika: {
      label: "Image",
      name: "slika",
      error: "Please select your picture",
      validation: "Wrong picture",
      description: () => (
        <>
          <h4>Drop files here or click to upload.</h4>
          <span className="text-muted font-13">Only images, max 6MB</span>
        </>
      ),
      key: "",
      placeholder: "",
    },
  },
  evidencijaForm: {
    buttonForward: "Sign",
    buttonBack: "Back",
  },
  successModal: {
    title: "Data Entry",
    body: "Data addition has been successfully completed. Select OK to continue.",
    buttonOk: "OK",
  },
  txtPotvrda:
    "By selecting the Sign option, I confirm that the task has been performed according to the instructions!",
  errorMissingInput: "Please fill in all fields",
};

interface InputField {
  label: string;
  key: string;
  placeholder: string;
  name?: string;
  error?: string;
  validation?: string;
  description?: () => JSX.Element;
}

interface Input {
  naziv: InputField;
  primjena: InputField;
  upustvoZaUpotrebu: InputField;
  vrsta: InputField;
  slika: InputField;
}

interface EvidencijaForm {
  buttonForward: string;
  buttonBack: string;
}

interface SuccessModal {
  title: string;
  body: string;
  buttonOk: string;
}

interface IErrors {
  registerPic: string;
  recordAlreadyExists: string;
}

export interface DEZSR_V1ResourcesBSInterface {
  labelDone: string;
  input: Input;
  evidencijaForm: EvidencijaForm;
  successModal: SuccessModal;
  txtPotvrda: string;
  errorMissingInput: string;
  errors: IErrors;
}
